import { useEffect, useState } from "react";

/**
 * Reads the current theme from the `data-theme` attribute on <html>
 * and re-renders when it changes. Used by consumers that can't hook
 * into the ThemeToggle state directly (e.g. Sonner Toaster).
 */
export default function useThemeAttr() {
  const [theme, setTheme] = useState(() => {
    if (typeof document === "undefined") return "dark";
    return document.documentElement.getAttribute("data-theme") || "dark";
  });

  useEffect(() => {
    if (typeof document === "undefined") return;
    const el = document.documentElement;
    setTheme(el.getAttribute("data-theme") || "dark");
    const mo = new MutationObserver(() => {
      setTheme(el.getAttribute("data-theme") || "dark");
    });
    mo.observe(el, { attributes: true, attributeFilter: ["data-theme"] });
    return () => mo.disconnect();
  }, []);

  return theme;
}
